import { atom, useAtom } from 'jotai';

const mapBoundsAsStringAtom = atom<string>('');
const mapBoundsAsCardinalDirectionsAtom = atom<
  | {
      north: number;
      east: number;
      south: number;
      west: number;
    }
  | undefined
>(undefined);

export const useMapBoundsAsString = () => useAtom(mapBoundsAsStringAtom);
export const useMapBoundsAsCardinalDirections = () =>
  useAtom(mapBoundsAsCardinalDirectionsAtom);

export const useMapBoundsState = () => {
  const [mapBoundsAsString, setMapBoundsAsString] = useMapBoundsAsString();
  const [mapBoundsAsCardinalDirections, setMapBoundsAsCardinalDirections] =
    useMapBoundsAsCardinalDirections();

  const updateBoundsState = (bounds: google.maps.LatLngBounds | undefined) => {
    if (!bounds) {
      return;
    }
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const north = ne.lat();
    const east = ne.lng();
    const south = sw.lat();
    const west = sw.lng();

    setMapBoundsAsString(bounds.toUrlValue());
    setMapBoundsAsCardinalDirections({ north, east, south, west });
  };

  return {
    mapBoundsAsString,
    setMapBoundsAsString,
    mapBoundsAsCardinalDirections,
    setMapBoundsAsCardinalDirections,
    updateBoundsState,
  };
};
